import Carousel from "react-bootstrap/Carousel";
import LazyImage from "./commons/LazyImage";

import desktopGroceryBanner from "../assets/BANNER DESKTOP -  252.jpg";
import mobileGroceryBanner from "../assets/BANNER MOBILE.jpg";
import desktopDeliveryBanner2 from "../assets/desktop-delivery-banner.webp";
import mobileDeliveryBanner2 from "../assets/mobile-delivery-banner.webp";

const HomeBanners = ({ isMobile, isPaused, handleImageClick }) => {
  const banners = [
    {
      src: isMobile ? mobileGroceryBanner : desktopGroceryBanner,
      alt: "We deliver fresh groceries",
    },
    {
      src: isMobile ? mobileDeliveryBanner2 : desktopDeliveryBanner2,
      alt: "Immediate fresh food delivery ",
    },
  ];

  return (
    <section className="pt-2 px-0 px-xl-3 pb-0 mb-0">
      <div className="custom-carousel-container mb-0">
        <Carousel
          indicators={true}
          controls={!isMobile}
          interval={isPaused ? null : 3000}
          className="custom-carousel mb-0 pb-0"
        >
          {banners.map((banner, index) => (
            <Carousel.Item key={index} className="mb-0 pb-0">
              <div className="banner-wrapper " onClick={handleImageClick}>
                <LazyImage
                  src={banner.src}
                  alt={banner.alt}
                  priority={index === 0 ? "true" : "false"}
                  style={{ borderRadius: "15px" }}
                />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default HomeBanners;
